<template>
  <div class="full-control" v-if="showNavMenu" style="box-shadow: 2px 8px 8px 2px rgba(0,0,0,0.2); ">
    <div class="header-sidebar"  slot="header">
        <img v-lazy="'https://cdn.redgirasol.com/green/LOGOS/redgirasol.png'" alt="Logotipo" class="img-responsive">
    </div>

    <div class="list">
      <side-bar-route-list
        :expand-single="expandSingle"
        :menuItems="itemSorted"></side-bar-route-list>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import SideBarRouteList from "@views/template/SideBar/SideBarRouteList";

export default {
  components: {SideBarRouteList},
  data: () => ({
    expandSingle: false,
  }),
  computed: {
    itemSorted() {
      return this.items.sort((item) => item.order);
    },
    ...mapState("menu", ["items", 'showNavMenu', 'rolesOfUser']),
    ...mapState("auth", ["user"]),
  }
}
</script>
<style scoped>
.header-sidebar {
  background: #3b3a3e;
}

.img-responsive {
  width: 60%;
  padding-top: 14px;
  padding-bottom: 12px;
  padding-left: 25px;
}
</style>
